import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "yiyuan",
  "use": "yiyuan-usage",
  "viewBox": "0 0 1160 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1160 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"yiyuan\"><path d=\"M1041.066667 921.6h102.4v102.4H17.066667v-102.4h102.4V51.2A51.2 51.2 0 0 1 170.666667 0h819.2a51.2 51.2 0 0 1 51.2 51.2V921.6z m-512-614.4h-102.4v102.4h102.4v102.4h102.4v-102.4h102.4V307.2h-102.4V204.8h-102.4v102.4zM682.666667 921.6h102.4v-307.2H375.466667v307.2h102.4v-204.8h204.8v204.8z\" fill=\"\" p-id=\"6694\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol